import React, {Component} from 'react';
const { connect } = require('react-redux');
import queryString from 'query-string';

import '../sass/virtualgift.scss';

import HeaderVirtualGifts from 'components/virtualgift/HeaderVirtualGifts';
import Footer from 'components/Footer';
import VirtualGiftCatalogItem from 'components/virtualgift/VirtualGiftCatalogItem';
import ModalGiveVirtualGift from 'components/modals/ModalGiveVirtualGift'


import {t} from 'l10n';

import {getVirtualGifts} from 'reducers/virtualGifts';
import LoginRedirect from '../components/LoginRedirect';

class VirtualGifts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedGiftCatalogItem: null
        }
    }

    loadData(props) {
        let {location} = props;
        let queryParams = queryString.parse(location.search);

        this.props.getVirtualGifts(queryParams.r);
    }

    componentDidMount() {
        this.loadData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search)
            this.loadData(nextProps);
    }

    render() {
        let {currentUser, virtualGifts, location} = this.props,
            {giftCatalogItems, user} = virtualGifts;

        let {selectedGiftCatalogItem} = this.state;

        if (!currentUser.isLoggedIn()) {
            return <LoginRedirect returnPath={location.pathname+(location.search ? location.search : '')}/>
        }

        return (
            <div id="wrapper">
                <HeaderVirtualGifts user={user}/>

                <ModalGiveVirtualGift
                    giftCatalogItem={selectedGiftCatalogItem}
                    user={user}
                    currentUser={currentUser}
                    show={!!selectedGiftCatalogItem}
                    closeFn={() => this.setState({selectedGiftCatalogItem: null})}
                />

                <aside className="list-gift">
                    <div className="content">
                        <p className="name">{t('%1 tokens in your virtual wallet', currentUser.counters.amount_wallet)}</p>
                        <div className="gifts flex">
                            {giftCatalogItems.map((item, index) =>
                                <VirtualGiftCatalogItem
                                    giftCatalogItem={item}
                                    onClick={(giftCatalogItem) => this.setState({selectedGiftCatalogItem: giftCatalogItem})}
                                    key={index}
                                />
                            )}
                        </div>
                    </div>
                </aside>
                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        virtualGifts: state.virtualGifts
    }),
    {
        getVirtualGifts: getVirtualGifts
    }
)(VirtualGifts)


// WEBPACK FOOTER //
// ./src/containers/VirtualGifts.js